module.exports = __webpack_public_path__ + "img/lqrefres.0b6e53ac.svg";